module.exports = __webpack_public_path__ + "../resources/img/ic_arrow_right_disabled.a2c9168c.svg";